import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// `withCredentials` ensures the httpOnly `jspa_token` cookie set by the
// backend on /auth/login is sent on every subsequent request. The cookie
// is the primary (XSS-safe) auth transport; the localStorage fallback
// below remains only to grandfather existing sessions during rollout.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  // Backward-compat: legacy sessions still have a token in localStorage.
  // The backend prefers the cookie but accepts Authorization: Bearer.
  const token = localStorage.getItem("jspa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("jspa_token");
    }
    return Promise.reject(err);
  }
);

export function formatSAR(n) {
  const num = Number(n || 0);
  return `${num.toLocaleString("en-US", { maximumFractionDigits: 2 })} ر.س`;
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}


// ---------------------------------------------------------------------------
// Saudi customer phone validation (mirrors backend _normalize_customer_phone)
// ---------------------------------------------------------------------------
// Mobile numbers after the +966 country code are exactly 9 digits and must
// start with "5". The SPA's own WhatsApp line is blacklisted so cashiers
// don't accidentally register the business line as a customer.
export const SPA_OWN_PHONE_DIGITS = "552221465";

/**
 * Validate a raw customer phone string. Returns an object:
 *   { ok: true, phone: "+966 5XXXXXXXX" }  OR
 *   { ok: false, reason: "spa" | "format" }
 * The caller decides the i18n error message.
 */
export function validateCustomerPhone(raw) {
  const digits = String(raw || "").replace(/\D/g, "")
    .replace(/^00966/, "")
    .replace(/^966/, "");
  if (digits === SPA_OWN_PHONE_DIGITS) return { ok: false, reason: "spa" };
  if (!/^5\d{8}$/.test(digits)) return { ok: false, reason: "format" };
  return { ok: true, phone: `+966 ${digits}` };
}
